import { IPhoto, IVideo } from '../interfaces/heavyDutyMachinery/IMedia';
import { apiUploadService } from './ApiService';
import { API_ENDPOINTS } from '../constants/apiEndpoints';

// HeavyDutyMachineryApi's own host (own Blob Storage container, "heavyDutyMachinery"
// — see MediaController), same as HeavyDutyMachineryService.
const heavyDutyMachineryBaseUrl = process.env.REACT_APP_HEAVY_DUTY_MACHINERY_API_URL || '';

// Keep in sync with MediaController.AllowedDomains on the backend.
// "bookings" is for delivery-site photos/videos a guest uploads at checkout
// (see HeavyDutyMachineryBookingWidget's delivery step). "accessories" is
// for MachineryAccessoryPhoto -- public URLs, same tier as "spaces", since
// they need to render in an anonymous checkout page. "serviceProviders" is
// for ServiceProviderProfile.ProfilePhotoUrl, same tier as "hosts" (see
// ServiceProviderOnboardingWizard).
export type MediaDomain = 'spaces' | 'hosts' | 'bookings' | 'accessories' | 'serviceProviders';

export const uploadPhotos = async (domain: MediaDomain, files: File[]): Promise<IPhoto[]> => {
  const formData = new FormData();
  files.forEach((file) => formData.append('files', file));

  const response = await apiUploadService<IPhoto[]>({
    url: API_ENDPOINTS.HEAVY_DUTY_MACHINERY_MEDIA_PHOTOS,
    formData,
    params: { domain },
    baseUrl: heavyDutyMachineryBaseUrl,
  });

  if (response.success) return response.data;
  throw new Error(response.error || 'Failed to upload photos');
};

export const uploadVideos = async (domain: MediaDomain, files: File[]): Promise<IVideo[]> => {
  const formData = new FormData();
  files.forEach((file) => formData.append('files', file));

  const response = await apiUploadService<IVideo[]>({
    url: API_ENDPOINTS.HEAVY_DUTY_MACHINERY_MEDIA_VIDEOS,
    formData,
    params: { domain },
    baseUrl: heavyDutyMachineryBaseUrl,
  });

  if (response.success) return response.data;
  throw new Error(response.error || 'Failed to upload videos');
};
